<template>
  <pb-modal
    width="350"
    v-model="toggle"
    :topCloseVisible="false"
    :onClose="closeHandler"
    @confirm="confirmHandler"
  >
    <template slot="header">
      {{ title }}
    </template>
    <div class="pb-confirm">
      <div class="pb-confirm__title"></div>
      <div class="pb-confirm__content" v-html="content"></div>
    </div>
  </pb-modal>
</template>

<script>
export default {
  name: "PbConfirm",
  props: {
    show: Boolean,
    title: String,
    content: String,
  },
  computed: {
    toggle: {
      set(newValue) {
        if (!newValue) {
          this.$emit("close");
        }
      },
      get() {
        return this.show;
      },
    },
  },
  methods: {
    confirmHandler() {
      this.$emit("confirm");
      this.$emit("close");
    },

    closeHandler() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.pb-confirm {
  &__content {
    line-height: 1.5;
  }
}
</style>
